import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { resolveImportStageFromState } from "../helpers/importStageHelper";

const useImportResultLabels = () => {
  const { t } = useTranslation();
  const state = useSelector((store) => store);
  const stage = resolveImportStageFromState(state);
  const isCreateImport = stage === "pre" || stage === "term";

  return {
    isPreImport: stage === "pre",
    savedColumnLabel: isCreateImport
      ? t("admin.importdata.column.saved", "Guardado")
      : t("admin.importdata.column.updated", "Actualizado"),
    savedSummaryLabel: isCreateImport
      ? t("admin.importdata.summary.saved", "Total de Registros Guardados:")
      : t("admin.importdata.summary.updated", "Total de Registros Actualizados:")
  };
};

export default useImportResultLabels;
